import { ChangeDetectorRef, Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import { CLPUser } from '../../../models/clpuser.model'
import { GridConfigurationService } from '../../../services/shared/gridConfiguration.service';
import { Router } from '@angular/router';
import { Company } from '../../../models/company.model';
import { isNullOrUndefined } from 'util';
import { LocalService } from '../../../services/shared/local.service';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

@Component({
    selector: 'app-company-grid',
    templateUrl: './company-grid.component.html',
    styleUrls: ['./company-grid.component.css'],
    providers: [GridConfigurationService]
})
export class CompanyGridComponent {
    @ViewChild(MatSort) sort: MatSort;
    @ViewChild(MatPaginator) paginator: MatPaginator;
    companyListSource: MatTableDataSource<any>;
    companyListDisplayColumns: string[] = [];
    showSpinner: boolean = false;
    @Input() isCompanyCreate: boolean = false;
    @Input() user: CLPUser;
    @Input() companyList: Company[] = [];
    dateFormat: string;

    columns = [
        { field: '$', title: '', width: '30' },
        { field: '$$', title: '', width: '40' },
        { field: 'companyName', title: 'Company', width: '250' },
        { field: 'webSite', title: 'webSite', width: '250' },
        { field: 'phone', title: 'phone', width: '50' },
        { field: 'numContacts', title: '# of Contacts', width: '50' },
        { field: 'city', title: 'city', width: '50' },
        { field: 'state', title: 'state', width: '50' },
        { field: 'firstName', title: 'User', width: '50' },
        { field: 'dtModified', title: 'Modified', width: '50' },
        { field: 'dtCreated', title: 'Created', width: '50' }
    ];

    reorderColumnName: string = 'companyName,webSite,phone,numContacts,city,state,firstName,dtModified,dtCreated';
    columnWidth: string = 'companyName:200,webSite:250,phone:120,numContacts:90,city:90,state:120,firstName:70,dtModified:90,dtCreated:90';
    arrColumnWidth: any[] = ['companyName:200,webSite:250,phone:120,numContacts:90,city:90,state:120,firstName:70,dtModified:90,dtCreated:90']
    gridHeight;

    constructor(public _gridCnfgService: GridConfigurationService,
        private _router: Router,
        private cdr: ChangeDetectorRef,
        public _localService: LocalService) {
        this.gridHeight = this._localService.getGridHeight('464px');
    }

    ngOnInit() {
        if (!isNullOrUndefined(this.user)) {
            this.dateFormat = this.user.dateFormat;
            //this.getCompanyGridConfiguration();
        }
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['companyList'] && this.companyList) {
            this.setGrid(this.companyList);
        }

    }
    rowSelectionCompanyChange(clpid) {
        this._router.navigateByUrl(`company-create?cid=${clpid}`);
    }


    //getCompanyGridConfiguration() {
    //    this._gridCnfgService.columns = this.columns;
    //    this._gridCnfgService.reorderColumnName = this.reorderColumnName;
    //    this._gridCnfgService.columnWidth = this.columnWidth;
    //    this._gridCnfgService.arrColumnWidth = this.arrColumnWidth;
    //    this._gridCnfgService.user = this.user;
    //    this._gridCnfgService.getGridColumnsConfiguration(this.user.cLPUserID, 'company_grid').subscribe((value) => this._gridCnfgService.createGetGridColumnsConfiguration('company_grid').subscribe((value) => { }));
    //}

    //resetGridSetting() {
    //    this._gridCnfgService.deleteColumnsConfiguration(this.user.cLPUserID, 'company_grid').subscribe((value) => this.getCompanyGridConfiguration());
    //}

    goToLinkCompanyList(dataItem: Company, value: string) {
        if (!isNullOrUndefined(value)) {
            switch (value) {
                case 'userName':
                    return `/edit-profile/${dataItem?.cLPUserID}`;
                    break;
                case 'website':
                    const route = 'https://' + dataItem?.webSite;
                    window.open(route, '_blank');
                    break;
            }
        }
    }

    onPageChange(event: any) {
        localStorage.setItem('pageSize', event.pageSize);
    }

    getSerialNumber(index: number): number {
        return index + 1 + (this.paginator?.pageIndex || 0) * (this.paginator?.pageSize || 5);
    }

    setGrid(list) {
        console.log(list)
        this.companyListDisplayColumns = this.columns.map(c => c.field);
        this.companyListSource = new MatTableDataSource(list);

        this.addTimeout(() => {
            this.companyListDisplayColumns = this.columns.map(c => c.field);
            this.companyListSource = new MatTableDataSource(list);
            if (this.paginator) {
                this.paginator.pageSize = this._localService.getPageSize('company_grid') ? this._localService.getPageSize('company_grid'): 50;
            }
            if (this.sort) {
                this.companyListSource.sort = this.sort;
                const sortState: Sort = this._localService.getSortState('company_grid');
                this.sort.active = sortState?.active;
                this.sort.direction = sortState?.direction;
                this.sort.sortChange.emit(sortState);
            }
        }, 500)

        this.cdr.detectChanges();
    }

    private timeouts = new Set<ReturnType<typeof setTimeout>>();
    addTimeout(callback, timeout) {
        const id = setTimeout(() => {
            if (callback) {
                callback();
            }
            this.timeouts.delete(id);
        }, timeout);
        this.timeouts.add(id);
    }

    ngOnDestroy() {
        this.timeouts.forEach(id => clearTimeout(id));
        this.timeouts.clear();
    }
}
